<template>
  <div
    v-bind:class="[
      'gallery-container',
      'grid',
      { current: shirt.is_current_sotw },
    ]"
  >
    <img :src="shirt.image_url" class="image" alt="" v-if="shirt.image_url" />
    <img src="/assets/img/fabric-placeholder.png" class="image" alt="" v-else />
    <div v-if="shirt.sotw_start_date" class="sow_date">
      {{ shirt.sotw_start_date }} - {{ shirt.sotw_end_date }}
    </div>
    <h4>{{ shirt.shirt_title }}</h4>
  </div>
</template>

<script>
export default {
  props: ["shirt"],
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
.gallery-container {
  background-color: white;
}
.gallery-container.current {
  background-color: orange;
}
.gallery-container h4 {
  padding: 0 15px 15px;
  text-align: center;
  font-weight: 600;
  font-size: 17px;
  height: 37px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
}
.gallery-container.current h4 {
  color: white;
}
.gallery-container img {
  max-width: 100%;
}
.gallery-container .sow_date {
  position: absolute;
  padding: 10px;
  background-color: white;
  bottom: 75px;
  right: 0;
  left: 0;
  margin: 0 15px;
  text-align: center;
}
</style>
